import { IS_PRISTINE_STORAGE_KEY } from '../constants'

export const setIsPristine = (isPristine: boolean) => {
  sessionStorage.setItem(IS_PRISTINE_STORAGE_KEY, String(isPristine))
}

export const removeIsPristine = () => {
  sessionStorage.removeItem(IS_PRISTINE_STORAGE_KEY)
}

export const getIsPristine = () => {
  return sessionStorage.getItem(IS_PRISTINE_STORAGE_KEY)
}
